// Models
import { AgentsActionTypes } from 'app/modules/agentsOld/models';

// Loading
export const selectImpersonationLoading = (state: RootState) =>
  Boolean(state.loading[AgentsActionTypes.START_IMPERSONATION]);
